import React from "react";
import ErrorMessage from "components/Form/ErrorMessage";

const isRecord = (value: unknown): value is Record<string, unknown> =>
    typeof value === "object" && value !== null;

const formatRecursive = (values: unknown) => {
    if (isRecord(values) && values.message !== undefined) {
        return React.createElement(ErrorMessage, { error: values });
    }

    if (!isRecord(values)) return values;

    const errors: HashMap<unknown> = {};
    for (let key in values) {
        errors[key] = formatRecursive(values[key]);
    }
    return errors;
};

const formatErrorResponse = (responseData: { data: unknown }) => {
    const errors = {} as HashMap<unknown>;
    const data = responseData?.data;
    if (!isRecord(data)) return errors;

    Object.keys(data).forEach((key) => {
        const value = data[key];
        if (key.includes(".")) {
            const split = key.split(".");
            split.reduce<Record<string, unknown>>((acc, current, index) => {
                if (index === split.length - 1) {
                    acc[current] = value;
                } else {
                    const next = acc[current];
                    if (isRecord(next)) {
                        acc[current] = next;
                    } else {
                        acc[current] = {};
                    }
                }
                return acc[current] as Record<string, unknown>;
            }, errors as unknown as Record<string, unknown>);
        } else if (typeof value === "object" && value !== null) {
            errors[key] = Object.assign({}, errors[key] ?? {}, formatRecursive(value));
        } else {
            errors[key] = React.createElement(ErrorMessage, { error: value });
        }
    });

    return errors;
};

export default formatErrorResponse;
